// 关注用户
import addpb from './index.pb';
import unfollowpb from './unfollow.pb';
import publicpb from '../../base/public.pb';
import PbAjax from '../../lib/pbajax';
import loading from 'c-up-loading';
import events from '../../base/events';

let pbajax = new PbAjax();

let Follow = function() {};

Follow.prototype = Object.assign({}, {

    do(fuid) {
        let cfg = {
            service: 'service',
            api: '/follow/user/add',
            header: {
                userToken: UP.Global.getUserToken()
            }
        };

        fuid = (typeof fuid == 'string') ? Number(fuid) : fuid;

        let requestData = new addpb.Follow.UserAdd.Request({
            fuid
        });

        pbajax.do(cfg, requestData, (res) => {
            let dataWrap = publicpb.Result.decode(res);
            if (dataWrap.code == 1) {

                loading.hide();

                this.emit('followSuccess', fuid);
            }
        }, () => {
            loading.hide();
        }, () => {
            loading.hide();
        });
    },
    unFollow(fuid) {

        let cfg = {
            service: 'service',
            api: '/follow/user/unfollow',
            header: {
                userToken: UP.Global.getUserToken()
            }
        };
        let requestData = new unfollowpb.Follow.UserUnfollow.Request({
            fuid
        });

        pbajax.do(cfg, requestData, (res) => {
            let dataWrap = publicpb.Result.decode(res);

            if (dataWrap.code == 1) {
                this.emit('unFollowSuccess');
            }
        }, () => {
            loading.hide();
        }, () => {
            loading.hide();
        });
    }

}, events);

export default Follow;



// WEBPACK FOOTER //
// ./js/component/follow/index.js